import { StaySearch } from '@components/stay/search';
import { BedDouble, Store } from 'lucide-react';
import React, { useState } from 'react';
import { ShopSearch } from './shopsearch';

type Mode = 'hotels' | 'shops';

const TABS: { mode: Mode; label: string; icon: React.ReactNode }[] = [
    { mode: 'hotels', label: 'Hotels', icon: <BedDouble className="w-4 h-4" /> },
    { mode: 'shops', label: 'Stores & products', icon: <Store className="w-4 h-4" /> },
];

// Hero search: hotels first (the default tab), with the marketplace search one tap away.
export const HomeSearch: React.FC<{ className?: string }> = ({ className = '' }) => {
    const [mode, setMode] = useState<Mode>('hotels');
    return (
        <div className={`flex flex-col gap-3 ${className}`}>
            <div role="tablist" aria-label="What are you looking for?" className="inline-flex self-start rounded-full bg-white/10 border border-white/15 p-1">
                {TABS.map((t) => (
                    <button key={t.mode} type="button" role="tab" aria-selected={mode === t.mode}
                        onClick={() => setMode(t.mode)}
                        className={`inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold border-0 cursor-pointer transition-colors ${mode === t.mode ? 'bg-white text-neutral-900' : 'bg-transparent text-white/80 hover:text-white'}`}>
                        {t.icon}{t.label}
                    </button>
                ))}
            </div>
            {mode === 'hotels' ? <StaySearch /> : <ShopSearch />}
        </div>
    );
};
